module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "exportTranslation",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.U1051))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.U1052))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            U1049\n            " + _vm._s(_vm.lang.U1049) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.downloadTranslationExportData()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.U1056) + "\n          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "importTranslation",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.U1041))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.U1042))])]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs nav-import",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#textImport",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.importTranslationDialogData.selectedOption = 'text'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.U1043))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#fileImport",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.importTranslationDialogData.selectedOption = 'file'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.U1044))])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "importTabContent"
    }
  }, [_c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "id": "textImport"
    }
  }, [_c('label', {
    staticClass: "col-md-1 control-label",
    attrs: {
      "for": "textAreaImport"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1045))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-11"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.importTranslationDialogData.selectedText),
      expression: "importTranslationDialogData.selectedText"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "7",
      "id": "textAreaImport"
    },
    domProps: {
      "value": (_vm.importTranslationDialogData.selectedText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.importTranslationDialogData, "selectedText", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.lang.U1046))])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "fileImport"
    }
  }, [_c('label', {
    staticClass: "col-md-1 control-label",
    attrs: {
      "for": "inputFileImport"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1047))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-11"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "multiple": "",
      "accept": ".csv, .xls, .xlsx"
    },
    on: {
      "change": _vm.onImportFileChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [(
    typeof _vm.importTranslationDialogData.selectedFile
    .name == 'undefined'
  ) ? _c('label', {
    staticStyle: {
      "padding-top": "16px"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1048))]) : _c('label', {
    staticStyle: {
      "padding-top": "16px"
    }
  }, [_vm._v(_vm._s(_vm.importTranslationDialogData.selectedFile.name))]), _vm._v(" "), _vm._m(0)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.U1049) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.uploadImportData()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.U1050) + "\n          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "translateSurveyDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "id": "surveyTranslateForm"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.closeTranslateSurveyDialog()
      }
    }
  }, [_vm._v("\n              ×\n            ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.dialogTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "surveyTranslationTopRow"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "translate-label control-label",
    attrs: {
      "for": "inputSurveyLanguage"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1018))]), _vm._v(" "), _c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "inputSurveyLanguage",
      "width": '200px',
      "afterChange": _vm.selectedLanguageChanged,
      "placeholder": _vm.lang.U1072
    },
    model: {
      value: (_vm.selectedLanguage),
      callback: function($$v) {
        _vm.selectedLanguage = $$v
      },
      expression: "selectedLanguage"
    }
  }, _vm._l((_vm.surveyLocales), function(value) {
    return _c('option', {
      key: value.LocaleCode,
      domProps: {
        "value": value.LocaleCode
      }
    }, [_vm._v("\n                    " + _vm._s(value.LocaleName) + "\n                  ")])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "disabled": _vm.translationList.length < 1 ||
        !_vm.globals.isAccessAllowed(
          'LoopOp_SurveyTranslationExport_Create'
        ),
      "data-toggle": "modal",
      "data-target": "#exportTranslation"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.U0056) + "\n                ")]), _vm._v(" "), (_vm.globals.currentUserRole == 1) ? _c('button', {
    staticClass: "btn btn-raised",
    class: {
      'btn-success': !_vm.translationData.AllowAgencyEdit,
      'btn-warning': _vm.translationData.AllowAgencyEdit,
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedLanguage
    },
    on: {
      "click": function($event) {
        return _vm.toggleAgencyTranslatePermission()
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.translationData.AllowAgencyEdit ? _vm.lang.U1071 : _vm.lang.U1070) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.globals.currentUserRole == 2) ? _c('button', {
    staticClass: "btn btn-raised btn-success",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedLanguage || !_vm.translationData.AllowAgencyEdit
    },
    on: {
      "click": function($event) {
        return _vm.submitTranslationsFromAgency()
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.U1073) + "\n                ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "modalScrollableArea",
    attrs: {
      "id": "surveyTranslation"
    }
  }, _vm._l((_vm.translationList), function(item, key) {
    return _c('div', {
      key: key
    }, [(_vm.isNewGroup(item.ParentId) && !item.QuestionName) ? _c('hr') : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group col-md-12"
    }, [_c('label', {
      staticClass: "col-md-6 translate-label",
      class: {
        'translate-label-child': item.Key !== 'title' && item.ParentId > 0,
      },
      attrs: {
        "for": 'textareaTranslationElement' + key
      }
    }, [(item.Key === 'title' && item.QuestionNumber) ? _c('span', [_vm._v(_vm._s(item.QuestionNumber) + " -")]) : _vm._e(), _vm._v("\n                      " + _vm._s(item.Name) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.Translation),
        expression: "item.Translation"
      }],
      staticClass: "form-control textarea-survey-translations autoExpand",
      attrs: {
        "id": 'textareaTranslationElement' + key,
        "maxlength": _vm.maxlength_textarea,
        "rows": "1",
        "disabled": _vm.globals.currentUserRole == 2 &&
          !_vm.translationData.AllowAgencyEdit,
        "placeholder": item.InheritedTranslation
      },
      domProps: {
        "value": (item.Translation)
      },
      on: {
        "change": function($event) {
          _vm.translationListDirty = true
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "Translation", $event.target.value)
        }
      }
    })])]), _vm._v("\n                  " + _vm._s(_vm.setNewGroup(item.ParentId)) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "row modal-footer"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeTranslateSurveyDialog()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.U1057) + "\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised",
    class: {
      'btn-warning': _vm.translationListDirty,
      'btn-success': !_vm.translationListDirty,
    },
    attrs: {
      "type": "button",
      "disabled": _vm.translationList.length < 1 ||
        !_vm.globals.isAccessAllowed(
          'LoopOp_SurveyTranslation_Update'
        ) ||
        (_vm.globals.currentUserRole == 2 &&
          !_vm.translationData.AllowAgencyEdit)
    },
    on: {
      "click": function($event) {
        return _vm.saveTranslateSurveyDialogData()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.U0023) + "\n              ")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn input-group-sm"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("attach_file")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d5b5a308","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SurveyManagement/SurveyManagementTranslateModal.vue
// module id = 657
// module chunks = 1 2